import styled from 'styled-components';

import { ArticleCaptionAndCredits } from 'editorial/components/ArticleCaptionAndCredits';
import { ArticleProductMarker } from 'editorial/components/ArticleProductMarker';
import { IVideo } from 'editorial/types/ArticleVideo';
import { LongFormVideo } from 'shared/components/LongFormVideo';

export const ArticleVideo = ({
  video,
  text,
  theme,
}: {
  video: IVideo;
  text?: string;
  theme: 'light' | 'dark';
}) => {
  const isPortrait = video.aspect < 1;
  const { productMarkers } = video;

  return (
    <ArticleVideo.Wrapper>
      {productMarkers?.map((marker) => {
        return (
          <ArticleProductMarker key={marker?.productTemplateSlug} marker={marker} openInNewWindow />
        );
      })}
      <ArticleVideo.VideoPlayerContainer $isPortrait={isPortrait}>
        <LongFormVideo
          {...video}
          theme={theme}
          width="100%"
          height="100%"
          eventLocation="editorial"
        />
        {text && <ArticleCaptionAndCredits caption={text} />}
      </ArticleVideo.VideoPlayerContainer>
    </ArticleVideo.Wrapper>
  );
};

ArticleVideo.Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

ArticleVideo.VideoPlayerContainer = styled.div<{ $isPortrait: boolean }>`
  display: block;
  min-width: ${({ $isPortrait }) => ($isPortrait ? '40%' : '100%')};
  max-width: ${({ $isPortrait }) => ($isPortrait ? '40%' : '100%')};

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.small}px) {
    min-width: 100vw;
    max-width: 100vw;
    margin-bottom: 30px;
  }
`;
